module.exports = __webpack_public_path__ + "static/media/fired.567cb529.png";